(function (angular) {
	'use strict';

	angular.module('ipoSharePriceChartModule', [
		'coreModule'
	]);
})(window.angular);